import * as Ably from "ably";
export const ablyClient = new Ably.Realtime({
  clientId: "ably-chat",
  key: "WJCElQ.MhQnkQ:YzC035Uju9RvzE5Ringp1LdV_VusuykbWMPCBawQluY",
});

export async function sendAblyMessage(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-message", {
      senderId,
      receiverId,
      text,
    });
    return { channelName, senderId, receiverId, text };
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}
export async function sendCashout(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-cash", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

export async function addCreditChannel(
  channelName,
  senderId,
  receiverId,
  text
) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish(channelName, {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

export async function RedeemChannel(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-redeem", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

export async function ResetPasswordChannel(
  channelName,
  senderId,
  receiverId,
  text
) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-reset", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}
